module.exports = __webpack_public_path__ + "static/media/manjaro_overlay-fs8.ebd824bf.png";